import { render, staticRenderFns } from "./TotalProfit.vue?vue&type=template&id=e2850762&"
import script from "./TotalProfit.vue?vue&type=script&lang=js&"
export * from "./TotalProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports